export const projectMixin = {
  methods: {
    isProjectSet (project) {
      return this.isProjectOpen(project) && project.current_participants >= project.min_participants
    },
    isProjectFull (project) {
      return this.isProjectOpen(project) && project.current_participants === project.max_participants
    },
    isProjectStillJoinable (project) {
      return this.isProjectSet(project) && !this.isProjectFull(project)
    },
    isProjectOpen (project) {
      return project.status === 'OPEN' && !this.isProjectClosed(project)
    },
    isProjectClosed (project) {
      let now = Math.trunc((new Date()).getTime() / 1000)
      let target = new Date(project.deadline_date.replace(/-/g, '/')).getTime() / 1000
      return project.status === 'CLOSED' || now >= target
    },
    isProjectDelivered (project) {
      return project.delivered
    },
    isProjectUserDelivered (project) {
      return project.user_delivered
    },
    isProjectApproved (project) {
      return project.approved
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/project.js